<template>
    <option v-if="cabin" :value="index">
        <i v-if="rate.brochure > 0"> van € {{ rate.brochure }}, voor </i>
        € {{ rate.prijs }} p.p.
        {{ rate.Type }}
        {{ cabin.naam }}
        {{ cabin.code }}
        <i
            v-if="cabin.isCampagne === this.rate.rateCode"
            v-html="cabin.campagneTitle"
        ></i>
        ({{ rateName }})
    </option>
</template>

<script>
export default {
    name: 'rateOption',
    props: {
        rate: Object,
        index: Number,
    },
    computed: {
        cabin: function() {
            let cabin = this.$store.getters.cabinDetail(this.rate.cabinCode)
            if (cabin === null) {
                console.log(
                    'Missing cabin for rate: ' + JSON.stringify(this.rate)
                )
            }
            return cabin
        },
        rateName: function() {
            return this.$store.getters.rateName(this.rate.rateCode)
        },
    },
}
</script>

<style scoped></style>
